import { getApiActionCreator } from 'helpers/actionHelper';
import { actionTypes } from './constants';

export const getTrendCommentsAction = getApiActionCreator(actionTypes.GET_TREND_COMMENTS_LIST_SETTINGS);
export const createAndEditTrendCommentAction = getApiActionCreator(actionTypes.CREATE_AND_EDIT_TREND_COMMENT_SETTINGS);
export const deleteTrendCommentAction = getApiActionCreator(actionTypes.DELETE_TREND_COMMENT_SETTINGS);

export const setTrendCommentsDrawerVisible = (visible, selectedCommentsList) => ({
    type: actionTypes.SET_TREND_COMMENTS_DRAWER_VISIBLE,
    visible,
    ...selectedCommentsList ? {
        selectedDataPointTimestamp: Array.isArray(selectedCommentsList)
            ? `${selectedCommentsList[0]?.timestamp} | ${selectedCommentsList[selectedCommentsList.length - 1]?.timestamp}`
            : selectedCommentsList?.timestamp
    } : {}
});

export const setTrendCommentsModalVisible = (visible, editCommentData, graphCommentTimestamp) => ({
    type: actionTypes.SET_TREND_COMMENTS_MODAL_VISIBLE,
    visible,
    editCommentData,
    graphCommentTimestamp
});

export const getTrendCommentsRequest = (from, to) => ({
    type: actionTypes.GET_TREND_COMMENTS_LIST_REQUEST,
    from,
    to
});

export const createAndEditTrendCommentRequest = (payload) => ({
    type: actionTypes.CREATE_AND_EDIT_TREND_COMMENT_REQUEST,
    payload,
});

export const deleteTrendCommentRequest = (commentId, callbackFn) => ({
    type: actionTypes.DELETE_TREND_COMMENT_REQUEST,
    commentId,
    callbackFn
});

export const clearCreateEditTrendCommentError = () => ({
    type: actionTypes.CLEAR_CREATE_EDIT_TREND_COMMENT_ERROR
});

export const clearDeleteTrendCommentError = () => ({
    type: actionTypes.CLEAR_DELETE_TREND_COMMENT_ERROR
});

export const resetTrendCommentSelection = () => ({
    type: actionTypes.RESET_TREND_COMMENT_SELECTION
});
